module.exports = __webpack_public_path__ + "static/img/rongxin.aa40038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rongxin.jpg
// module id = S9sA
// module chunks = 2 6